// @flow

import walmartSrc from './walmart-logo.png';
import samsClubSrc from './sams-club-logo.png';
import ahorroSrc from './farmacias-del-ahorro-logo.png';
import benavidesSrc from './benavides-logo.png';
import superamaSrc from './superama-logo.png';
import bodegaAurreraSrc from './bodega-aurrera-logo.png';
import guadalajaraSrc from './farmacias-guadalajara-logo.png';

type LocationIcon = {
  imgSrc: string,
  altText: string,
}

export function getLocationIcons(): ImmutableArray<LocationIcon> {
  return [
    {
      imgSrc: walmartSrc,
      altText: 'walmart',
    },
    {
      imgSrc: samsClubSrc,
      altText: 'samsClub',
    },
    {
      imgSrc: ahorroSrc,
      altText: 'ahorro',
    },
    {
      imgSrc: benavidesSrc,
      altText: 'benavides',
    },
    {
      imgSrc: superamaSrc,
      altText: 'superama',
    },
    {
      imgSrc: bodegaAurreraSrc,
      altText: 'bodegaAurrera',
    },
    {
      imgSrc: guadalajaraSrc,
      altText: 'guadalajara',
    },
  ];
}
